var _defs, _g, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInviteReceived = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .invite-received-class-a {\n        fill: white;\n      }\n      .invite-received-class-b {\n        fill: none !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_6134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.429 4H4.714C4.26082 4.00185 3.82686 4.18332 3.50725 4.50461C3.18764 4.8259 3.00847 5.26081 3.009 5.714L3 16C3.00132 16.4542 3.18232 16.8894 3.50348 17.2105C3.82463 17.5317 4.25982 17.7127 4.714 17.714H11.571V16H4.714V7.429L11.571 11.715L18.428 7.429V11.715H20.142V5.715C20.1409 5.26082 19.9602 4.82552 19.6392 4.50418C19.3183 4.18284 18.8832 4.00158 18.429 4ZM11.572 10L4.714 5.714H18.429L11.572 10ZM16.149 19.429L13.115 16.395L14.324 15.186L16.14 17L19.774 13.366L21 14.577L18.527 17.05L16.149 19.429Z",
    className: "invite-received-class-a"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_6134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    className: "invite-received-class-b"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInviteReceived);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invite_received.1751eeda7e393818e6b940c3a9eba95b.svg";